import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';

const FinalOffer = () => {
    document.title = "Onay ve Zamanlama | HarmanaGEL";
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Önceki sayfadan gelen masraf (Eğer direkt bu sayfaya girildiyse 0 al)
    const expenses = location.state?.expenses || 0;

    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const userId = authUser?.ID;

    const [loading, setLoading] = useState(false);
    const [existingOfferId, setExistingOfferId] = useState(null);

    const [date, setDate] = useState("");
    const [timeStart, setTimeStart] = useState("");
    const [timeEnd, setTimeEnd] = useState("");
    const [servicePrice, setServicePrice] = useState("");

    const totalOffer = (expenses + parseFloat(servicePrice || '0')).toFixed(2);

    // OData zaman parse ve format işlemleri
    const formatToDuration = (timeStr) => {
        if (!timeStr) return null;
        const [h, m] = timeStr.split(':');
        return `PT${parseInt(h)}H${parseInt(m)}M0S`;
    };

    const parseDurationToTime = (durationStr) => {
        if (!durationStr) return "";
        const match = durationStr.match(/PT(\d+)H(\d+)M/);
        if (match) {
            const h = match[1].padStart(2, '0');
            const m = match[2].padStart(2, '0');
            return `${h}:${m}`;
        }
        return "";
    };

    useEffect(() => {
        const loadExistingOffer = async () => {
            if (!userId || !id) return;
            try {
                const response = await fetch(`https://harmanappapi.stechomeyazilim.info/ILAN_TEKLIFLERI?$filter=ILANLAR_ID eq ${id} and KULLANICI_ID eq ${userId}`);
                const result = await response.json();
                
                if (result.value && result.value.length > 0) {
                    const offer = result.value[0];
                    setExistingOfferId(offer.ID);
                    setServicePrice(offer.Own_Offer?.toString() || "");
                    
                    if (offer.Delivery_Date) setDate(offer.Delivery_Date.split('T')[0]);
                    if (offer.Start_Time) setTimeStart(parseDurationToTime(offer.Start_Time));
                    if (offer.End_Time) setTimeEnd(parseDurationToTime(offer.End_Time));
                }
            } catch (error) {
                console.error("Teklif yükleme hatası:", error);
            }
        };
        loadExistingOffer();
    }, [id, userId]);

    const handleSendOffer = async () => {
        if (!servicePrice || !date || !timeStart || !timeEnd) {
            alert("Lütfen teslimat tarihini, saat aralığını ve teklifinizi doldurunuz.");
            return;
        }

        setLoading(true);
        try {
            const expNum = Number(expenses);
            const serviceNum = Number(servicePrice);
            const finalPrice = expNum + serviceNum;

            const payload = {
                Advert_ID: Number(id),
                Users_ID: Number(userId),
                Price: finalPrice,
                Travel_Expenses: expNum,
                Delivery_Date: date,
                Start_Time: formatToDuration(timeStart),
                End_Time: formatToDuration(timeEnd),
                Own_Offer: serviceNum,
                OLUSTURMA_TARIHI: new Date().toISOString(),
                IsUpdated: !!existingOfferId
            };

            const method = existingOfferId ? "PATCH" : "POST";
            const url = existingOfferId 
                ? `https://harmanappapi.stechomeyazilim.info/ILAN_TEKLIFLERI(${existingOfferId})`
                : "https://harmanappapi.stechomeyazilim.info/ILAN_TEKLIFLERI";

            const response = await fetch(url, {
                method: method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error("Teklif gönderilemedi");

            alert(existingOfferId ? "Teklifiniz başarıyla güncellendi!" : "Teklifiniz başarıyla iletildi!");
            navigate("/job-list"); // Başarılı olunca iş listesine dön

        } catch (error) {
            console.error("Hata:", error);
            alert("Teklif gönderilirken bir hata oluştu!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <div className="d-flex align-items-center mb-4">
                    <Link to={`/expense-entry/${id}`} className="text-dark me-3">
                        <i className="mdi mdi-arrow-left fs-3"></i>
                    </Link>
                    <h3 className="mb-0">Onay ve Zamanlama</h3>
                </div>

                <Row className="justify-content-center">
                    <Col lg={8}>
                        {/* ZAMANLAMA KARTI */}
                        <Card className="mb-4">
                            <CardBody>
                                <h5 className="card-title mb-4">Görev Zamanlaması</h5>
                                <FormGroup>
                                    <Label className="fw-bold">Teslimat Tarihi</Label>
                                    <Input type="date" value={date} onChange={e => setDate(e.target.value)} />
                                </FormGroup>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label className="fw-bold">Başlangıç Saati</Label>
                                            <Input type="time" value={timeStart} onChange={e => setTimeStart(e.target.value)} />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label className="fw-bold">Bitiş Saati</Label>
                                            <Input type="time" value={timeEnd} onChange={e => setTimeEnd(e.target.value)} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* HİZMET BEDELİ KARTI */}
                        <Card className="mb-4 border-primary">
                            <CardBody className="text-center">
                                <span className="badge bg-soft-primary text-primary mb-3 px-3 py-2">NET KAZANCINIZ</span>
                                <div className="d-flex justify-content-center align-items-center mb-2">
                                    <h3 className="text-primary me-2 mb-0">TL</h3>
                                    <Input 
                                        type="number" 
                                        placeholder="0.00" 
                                        className="form-control-lg text-center fs-2 fw-bold w-50" 
                                        value={servicePrice} 
                                        onChange={e => setServicePrice(e.target.value)} 
                                    />
                                </div>
                                <p className="text-muted mt-3">Girdiğiniz tutar, masraflar hariç <strong>sizin kârınız</strong> olacaktır.</p>
                            </CardBody>
                        </Card>

                        {/* ÖZET KARTI */}
                        <Card className="bg-light shadow-none border">
                            <CardBody>
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted fw-bold">Yol Masrafları</span>
                                    <span className="fw-bold">{expenses.toFixed(2)} TL <Link to={`/expense-entry/${id}`}><i className="mdi mdi-pencil text-primary ms-1"></i></Link></span>
                                </div>
                                <div className="d-flex justify-content-between mb-3 pb-3 border-bottom">
                                    <span className="text-muted fw-bold">Kendi Teklifiniz</span>
                                    <span className="fw-bold">{parseFloat(servicePrice || "0").toFixed(2)} TL</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="text-muted mb-0">TOPLAM TEKLİF</h5>
                                    <h3 className="text-primary mb-0">{totalOffer} TL</h3>
                                </div>
                            </CardBody>
                        </Card>

                        <div className="d-grid mt-4">
                            <Button color="primary" size="lg" onClick={handleSendOffer} disabled={loading || !servicePrice || !date || !timeStart || !timeEnd}>
                                {loading ? <Spinner size="sm" /> : <><i className="mdi mdi-check-circle me-2"></i> TEKLİFİ GÖNDER</>}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FinalOffer;